import { call, put, select, takeEvery } from 'redux-saga/effects';

import logger from 'middleware/logger';
import { getMeetSantaTimeslots, reserveMeetSantaTimeslot } from 'apis/mafia';
import {
  FETCH_SANTA_AVAILABLE_TIMESLOTS,
  ON_HAD_SANTA_FORM_SUBMISSION_STATUS,
  STORE_RESERVATION_WAS_SUCCESSFULLY_BOOKED,
  STORE_SANTA_API_RETURNED_UNEXPECTED,
  STORE_SANTA_AVAILABLE_TIMESLOTS,
  SUBMIT_SANTA_SIGNUP_FORM
} from 'store/ducks/santa/types';
import { withSession } from 'store/ducks/session/sagas';
import { getMafiaAndCredentials } from 'store/ducks/readFromStore';
import {
  REDIRECT,
  SET_FEDERATED_LOGIN_MODAL_VISIBILITY
} from 'constants/reduxActions';

export function* watchRequestMeetSantaTimeslots() {
  yield takeEvery(FETCH_SANTA_AVAILABLE_TIMESLOTS, workRequestMeetSantaTimeslots);
}

export function* workRequestMeetSantaTimeslots() {
  try {
    const { mafia, credentials } = yield select(getMafiaAndCredentials);
    const { payload: { json, status } } = yield call(withSession, [getMeetSantaTimeslots, mafia, credentials]);

    switch (status) {
      case 403: {
        yield put({
          type: SET_FEDERATED_LOGIN_MODAL_VISIBILITY,
          payload:  {
            isFederatedLoginModalShowing: true,
            redirectOnClose: '/',
            returnTo: '/c/santa'
          }
        });
        break;
      }
      case 200: {
        yield put({ type: STORE_SANTA_AVAILABLE_TIMESLOTS, payload: json });
        break;
      }
      default: {
        yield put({ type: STORE_SANTA_API_RETURNED_UNEXPECTED });
      }
    }

  } catch (e) {
    logger('error in workRequestMeetSantaTimeslots: ', e);
    yield put({ type: STORE_SANTA_API_RETURNED_UNEXPECTED });
  }
}

export function* watchReserveMeetSantaTimeslot() {
  yield takeEvery(SUBMIT_SANTA_SIGNUP_FORM, workReserveMeetSantaTimeslot);
}

export function* workReserveMeetSantaTimeslot({ date, time, timeInCustomerLocation }) {
  try {
    const { mafia, credentials } = yield select(getMafiaAndCredentials);
    const { payload: { json, status } } = yield call(withSession, [reserveMeetSantaTimeslot, mafia, date, time, timeInCustomerLocation, credentials]);

    yield put({ type: ON_HAD_SANTA_FORM_SUBMISSION_STATUS, status });

    switch (status) {
      case 403: {
        yield put({
          type: SET_FEDERATED_LOGIN_MODAL_VISIBILITY,
          payload:  {
            isFederatedLoginModalShowing: true,
            redirectOnClose: '/',
            returnTo: '/c/santa'
          }
        });
        break;
      }
      case 200:
      case 409: {
        yield put({ type: FETCH_SANTA_AVAILABLE_TIMESLOTS });
        yield put({ type: STORE_RESERVATION_WAS_SUCCESSFULLY_BOOKED });
        yield put({ type: REDIRECT, location: '/c/santa' });
        break;
      }
      case 404: {
        yield put({ type: STORE_SANTA_AVAILABLE_TIMESLOTS, payload: json });
        yield put({ type: STORE_REVERATION_WAS_UNSUCCESSFUL });
        break;
      }
      default: {
        yield put({ type: FETCH_SANTA_AVAILABLE_TIMESLOTS });
        yield put({ type: STORE_SANTA_API_RETURNED_UNEXPECTED });
      }
    }

  } catch (e) {
    logger('error in workReserveMeetSantaTimeslot: ', e);
    yield put({ type: STORE_SANTA_API_RETURNED_UNEXPECTED });
  }
}

export default [
  watchRequestMeetSantaTimeslots,
  watchReserveMeetSantaTimeslot
];
